<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  auth: {
    type: Object,
    default: null,
  },
});

const showBanner = ref(false);

// При загрузке страницы про согласие ничего не пишем: в консоли выглядело
// так, будто согласие только что получено, хотя кнопку никто не жал — просто
// в хранилище лежал прошлый выбор. Сообщаем только о фактическом нажатии.
onMounted(() => {
  const savedConsent = localStorage.getItem("yandex_metrica_consent");
  showBanner.value = savedConsent ? false : !props.auth;
});

const acceptConsent = () => {
  localStorage.setItem("yandex_metrica_consent", "accepted");
  showBanner.value = false;
  console.log("🍪 [Cookie Consent] ✅ Пользователь СОГЛАСИЛСЯ");
  console.log("📊 [Yandex.Metrica] Метрика работает");
};

const declineConsent = () => {
  localStorage.setItem("yandex_metrica_consent", "declined");
  showBanner.value = false;
  console.log("🍪 [Cookie Consent] ❌ Пользователь ОТКАЗАЛСЯ. Метрика выключена.");
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-3"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-200 ease-in"
    leave-to-class="opacity-0 translate-y-2"
  >
    <div
      v-if="showBanner"
      class="fixed bottom-[calc(0.5rem+var(--mobile-bar-h,0px))] lg:bottom-4 left-3 right-3 sm:left-auto sm:right-4 sm:max-w-md
             z-50 rounded-xl border border-gray-200/70 bg-white/95 backdrop-blur-sm
             shadow-[0_8px_24px_-8px_rgba(15,23,42,0.25)] transition-[bottom] duration-300"
      role="alert"
    >
      <!-- lg:bottom-4: нижний бар страницы услуги есть только до lg, а --mobile-bar-h он выставляет
           и на ПК — без этого плашка подскакивала вверх при прокрутке (04.11.2026).
           Одна строка: не перекрывает кнопки связи на первом экране телефона.
           Полный текст согласия — по ссылке «Подробнее» (/cookie, /personal). -->
      <div class="flex items-center gap-2 px-3 py-2">
        <p class="flex-1 min-w-0 text-xs leading-snug text-gray-600">
          Мы используем cookies и Яндекс.Метрику.
          <a href="/cookie" target="_blank" class="text-blue-600 hover:underline">Подробнее</a>
        </p>
        <button
          @click="acceptConsent"
          class="shrink-0 px-3 py-1.5 bg-gray-900 text-white rounded-lg text-xs font-semibold hover:bg-gray-700 active:scale-[0.98] transition"
        >
          ОК
        </button>
        <button
          @click="declineConsent"
          aria-label="Отказаться"
          class="shrink-0 w-7 h-7 inline-flex items-center justify-center text-gray-400 rounded-lg hover:bg-gray-100 hover:text-gray-600 transition"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
    </div>
  </Transition>
</template>
